import { httpClient } from '../httpClient';
import { TenantInfoResponse } from '@packages/global';

export class TenantApi {
  async fetchTenantInfo(): Promise<TenantInfoResponse> {
    return httpClient.get<TenantInfoResponse>('/public/tenant/info');
  }
}

export const tenantApi = new TenantApi();
